// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__r1lLw","createdSearch":"index_createdSearch__+gUM2","custom_table":"index_custom_table__VZuYN"};